<section class="vr-installment-section mt-5 mb-5">
  <div class="container-fluid">


    <div class="row">
      <div class="col-md-12">
        <div class="card w-100">
          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <h2 class="vrf">Buy Now, Pay Monthly</h2>
              </div>

            </div>

          </div>
          <div class="card-body vr-card-body">

            <div class="row">
              <div class="col-12">
                <h4 class="mb-4"><u>How It Works</u></h4>

                <ul class="vr-work-list">
                  <li>
                    <img src="assets/img/ny-true.png" />
                    Choose pay with installment on payment page.
                  </li>

                  <li>
                    <img src="assets/img/ny-true.png" />
                    Select your bank and choose method which suits you.
                  </li>

                  <li>
                    <img src="assets/img/ny-true.png" />
                    Make the payment online and you are good to go.
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card w-100">
          <div class="card-header">
            <div class="row">
              <div class="col-8 col-lg-9">
                <h2 class="vrf">Invoice</h2>
              </div>
              <div class="col-4 col-lg-3">
                <img src="assets/img/plogo.png" class="img-fluid" alt="img" />
              </div>
            </div>

          </div>
          <div class="card-body vr-card-body">

            <div class="row">
              <div class="col-md-5">


                <div class="table-responsive">
                  <table class="table table-bordered table-inst">
                    <tr class="table-inst-header">
                      <td colspan="2">
                        <h5>
                          <i class="fa fa-file-code-o"></i>  Invoice Details
                        </h5>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Merchant
                      </td>
                      <td>
                        Clockwork.app
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Invoice #
                      </td>
                      <td>
                        7
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Valid Until (GMT)
                      </td>
                      <td>
                        23 hours, 58 minutes
                      </td>
                    </tr>
                    <tr class="table-inst-footer">
                      <td>
                        Due Amount
                      </td>
                      <td class="vr-bg-light">
                        $ 120.00
                      </td>
                    </tr>
                  </table>
                </div>


              </div>
              <div class="col-md-7">
                <p class="mt-5 mt-md-0">
                  How do you want to pay for this invoice?
                  <span class="text-vr-color text-vr-font" style="font-size:17px">(click one of the options)</span>
                </p>

                <div class="vr-radio-box mt-3">
                  <label>
                    <input type="radio" name="cards" disabled />
                    Pay with Credit/Debit Cards
                  </label>
                  <img src="assets/img/vr-cards.png" alt="img" />
                </div>
                <div class="vr-radio-box vr-border mt-3">
                  <label>
                    <input type="radio" name="card" checked />
                    Pay with Installments
                  </label>
                  <img src="assets/img/vr-cards2.png" alt="img" />
                </div>
                <p class="text-vr-font mt-5" style="font-size:18px">
                  <label>
                    <input type="checkbox" checked />
                    I agree to <a href="">Terms and Conditions</a>
                  </label>
                </p>

                <div>
                  <a href="" class="btn vr-btn-03">
                    MAKE A PAYMENT
                  </a>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="row mt-5">
      <div class="col-md-12">
        <p class="text-success">Select your country</p>
        <select class="form-control vr-select">
          <option>United Arab Emirates</option>
          <option disabled>Saudi Arabia</option>

        </select>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-12">
        <p class="text-success">Select your Bank</p>

      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" checked />
            <img src="assets/img/v1.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" disabled />
            <img src="assets/img/v2.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" disabled />
            <img src="assets/img/v3.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" disabled />
            <img src="assets/img/v4.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" disabled />
            <img src="assets/img/v5.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>
      <div class="col-md-2 col-6">
        <div class="radio-img">
          <label>
            <input type="radio" class="rd_sel" name="bank" disabled />
            <img src="assets/img/v6.png" class="img-fluid" alt="img" />
          </label>
        </div>
      </div>


    </div>


    <div class="row mt-1 mb-4">
      <div class="col-md-12">
        <p class="text-success">Select your Plan</p>
        <div class="table-responsive mt-4">
          <table class="table table-striped plans-table">
            <tr>
              <th></th>
              <th>
                Number of Installments
              </th>
              <th>
                Bank's Interest Rate
              </th>
              <th>
                Monthly Installment Amount
              </th>
            </tr>
            <tr>
              <td>
                <input type="radio" name="number" disabled />
              </td>
              <td>
                3 months
              </td>
              <td>
                1.49%
              </td>
              <td>
                $ 217.88
              </td>
            </tr>
            <tr>
              <td>
                <input type="radio" name="number" disabled />
              </td>
              <td>
                6 months
              </td>
              <td>
                1.49%
              </td>
              <td>
                $ 217.88
              </td>
            </tr>
            <tr>
              <td>
                <input type="radio" name="number" disabled />
              </td>
              <td>
                9 months
              </td>
              <td>
                1.49%
              </td>
              <td>
                $ 217.88
              </td>
            </tr>
            <tr>
              <td>
                <input type="radio" name="number" checked />
              </td>
              <td>
                12 months
              </td>
              <td>
                1.49%
              </td>
              <td>
                $ 217.88
              </td>
            </tr>
          </table>
        </div>

        <div class="vr-note mb-4">
          <p>
            The bank interest rate is calculated  per month. The bank charges $ 49 as processing fees.
          </p>
        </div>
      </div>
    </div>


    <h1 class="text-center mt-5 mb-4">Partner Banks</h1>

    <div class="row partner-banks-ul">
      <div class="col-md-12">

        <img src="assets/img/partner/p-text_03.png" class="img-fluid mx-auto d-block" style="width:270px" alt="img" />

      </div>

    </div>

    <div class="row partner-banks-ul">
      <div class="col-md-12">
        <div class="cs-ul">
          <img src="assets/img/partner/p1_03.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p2_05.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p3_07.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p4_09.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul last-ul">
          <img src="assets/img/partner/p5_11.png" class="img-fluid" alt="img" />
        </div>
      </div>

    </div>


    <div class="row partner-banks-ul">
      <div class="col-md-12">
        <div class="cs-ul">
          <img src="assets/img/partner/p6_18.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p7_19.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p8_20.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/p9_21.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul last-ul">
          <img src="assets/img/partner/p10_22.png" class="img-fluid" alt="img" />
        </div>
      </div>

    </div>


    <div class="row partner-banks-ul">
      <div class="col-md-12">

        <img src="assets/img/partner/p11_28.png" class="img-fluid last-logo" alt="img" />

      </div>

    </div>

    <div class="row partner-banks-ul mt-5">
      <div class="col-md-12">

        <img src="assets/img/partner/s-text_34.png" class="img-fluid mx-auto d-block" style="width:310px" alt="img" />

      </div>

    </div>

    <div class="row partner-banks-ul mt-2">
      <div class="col-md-12">
        <div class="cs-ul">
          <img src="assets/img/partner/s1_30.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/s2_31.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/s3_32.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul">
          <img src="assets/img/partner/s4_33.png" class="img-fluid" alt="img" />
        </div>
        <div class="cs-ul last-ul">
          <img src="assets/img/partner/s5_34.png" class="img-fluid" alt="img" />
        </div>
      </div>

    </div>

  </div>
</section>






<section class="colored-section-bordered">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 col-xl-10 offset-xl-1">
        <div class="row">
          <div class="col-4 col-xl-4 d-flex">
            <div class="image-div w-100">
              <img src="assets/img/ic1_11.png" class="img-fluid" alt="img" />
              <p>FREE INSTALLATION</p>
            </div>
          </div>
          <div class="col-4 col-xl-4 d-flex">
            <div class="image-div w-100">
              <img src="assets/img/ic2_11.png" class="img-fluid" alt="img" />
              <p>FITMENT GUARANTEE</p>
            </div>
          </div>
          <div class="col-4 col-xl-4 d-flex">
            <div class="image-div w-100">
              <img src="assets/img/ic3_11.png" class="img-fluid" alt="img" />
              <p>BEST PRICES</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
